import Axios from "axios";
import {
  SET_INV_PO_RECEIVE_REPORT,
  UNSET_INV_PO_RECEIVE_REPORT,
} from "@/store/mutation-types";
import { getInvPoReceiveReport } from "@/store/api";

const state = {
  getInvPoReceiveReport: {},
};

const getters = {
  getInvPoReceiveReport(state) {
    return state.getInvPoReceiveReport;
  },
};

const mutations = {
  [SET_INV_PO_RECEIVE_REPORT](state, data) {
    state.getInvPoReceiveReport = data;
  },
  [UNSET_INV_PO_RECEIVE_REPORT](state) {
    state.getInvPoReceiveReport = {};
  },
};

const actions = {
  getInvPoReceiveReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvPoReceiveReport, { params })
        .then(function (response) {
          commit("SET_INV_PO_RECEIVE_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_PO_RECEIVE_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
